import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import documentService from "./document-upload-service";
import Utility from "../../../shared/utility.js";
import router from "../../../router/router";
export default {
  data: () => ({
    userId: EncryptUtility.localStorageDecrypt("userID"),
    route: "",
    mainPage: "",
    subPage: "",
    subPageUrl: "",
    appPageName: "",
    pageName: "",
    backSlash: true,
    backSlashParent: true,
    accountName: "",
    accountManager: "",
    backupManager: "",
    selectedOriginID: "",
    originOptions: [],
    selectedTypeName: "",
    typeOptions: [],
    selectedDocumentNum: "",
    documentTitle: "",
    versionRevision: "",
    author: "",
    engineer: "",
    engineerOptions: [],
    authorOptions: [],
    timeRequired: "",
    statusID: "",
    statusOptions: "",
    difficultyID: "",
    difficultyOptions: [],
    managementDoc: false,
    applicablePersonnel: "",
    personnelOptions: [],
    trainingRequired: false,
    draftVersion: false,
    isPublished: false,
    file: "",
    fileOther: [],
    dragging: false,
    draggingOther: false,
    accountMastersEditID: 0,
    documentDetails: [],
    refDocumentDetails: [],
    uploadedFileDialog: false,
    uploadedFileDialogWidth: "1100",
    uploadedRefFileDialogWidth: "1100",
    base64String: "",
    documentDelDialog: false,
    documentHistoryDialog: false,
    documentHistoryItems: [],
    actionLogData: [],
    publishedDate: "",
    deleteRefDocumentData: [],
    deleteRefDocumentDialog: false,
    popupString: "",
    popupFileName: "",
    uploadedReferenceFileDialog: false,
    required: [(v) => !!v || "Field is required"],
    max20Rule: [(v) => !!v || "Field is required", (v) => (v || "").length <= 20 || "Max Length must be 20 characters or less"],
    max30Rule: [(v) => !!v || "Field is required", (v) => (v || "").length <= 30 || "Max Length must be 30 characters or less"],
    max50Rule: [(v) => !!v || "Field is required", (v) => (v || "").length <= 50 || "Max Length must be 50 characters or less"],
    max100Rule: [(v) => !!v || "Field is required", (v) => (v || "").length <= 100 || "Max Length must be 100 characters or less"],
    headersDocumentHistory: [
      { text: "Version No", value: "version_number" },
      { text: "Original File Name", value: "original_file_name" },
      { text: "Uploaded By", value: "uploaded_by" },
      { text: "Uploaded Date", value: "uploaded_date" },
      { text: "Comments", value: "short_comments" },
    ],
    headersRefDocument: [
      { text: "Reference Document Name", align: "start", value: "original_file_name", class: "primary customwhite--text" },
      { text: "Actions", value: "actions", class: "primary customwhite--text" },
    ],
  }),
  computed: {
    frameSrc() {
      return this.base64String;
    },
    frameSrcReference() {
      if (!this.popupString) return "";
      const encodedUrl = encodeURIComponent(this.popupString);
      if (this.popupFileName === "pdf") {
        return this.popupString;
      }
      if (["docx", "pptx", "xlsx"].includes(this.popupFileName)) {
        return `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`;
      }
      if (this.popupFileName === "image") {
        return this.popupString;
      }
      return "";
    },
  },
  async created() {
    let dataSimple = await AddFavourite.getPageAction(this.userId, "document-account-edit");
    this.route = this.$route.path.replace("/", "").split("/")[0];
    let data = await AddFavourite.getParentPageAction(this.userId, this.route);
    this.actionList = dataSimple.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.subPageUrl = data.subPageUrl;
    this.appPageName = data.appPageName;
    this.accountMastersEditID = parseInt(atob(this.$route.params.accountMastersEditID));
    this.getDocumentActionLogs();
    this.loadDropdowns();
    this.getDocumentDetails();
  },
  mounted() {
    router.afterEach((to) => {
      if (
        !to.path.includes("document-account-add") &&
        !to.path.includes("document-account-edit") &&
        !to.path.includes("document-account-list") &&
        !to.path.includes("document-account-details")
      ) {
        EncryptUtility.localStorageRemoveItem("accountMastersDetails");
      }
    });
  },
  methods: {
    resetFunction() {
      this.accountName = "";
      this.accountManager = "";
      this.backupManager = "";
      this.selectedOriginID = "";
      this.originOptions = [];
      this.selectedTypeName = "";
      this.typeOptions = [];
      this.selectedDocumentNum = "";
      this.documentTitle = "";
      this.versionRevision = "";
      this.author = "";
      this.engineer = "";
      this.engineerOptions = [];
      this.authorOptions = [];
      this.timeRequired = "";
      this.statusID = "";
      this.statusOptions = "";
      this.difficultyID = "";
      this.difficultyOptions = [];
      this.managementDoc = false;
      this.applicablePersonnel = "";
      this.personnelOptions = [];
      this.trainingRequired = false;
      this.draftVersion = false;
      this.isPublished = false;
      this.file = "";
      this.dragging = false;
      this.fileOther = [];
      this.draggingOther = false;
      this.documentDetails = [];
      this.refDocumentDetails = [];
      this.uploadedFileDialog = false;
      this.base64String = "";
      this.documentDelDialog = false;
      this.documentHistoryDialog = false;
      this.documentHistoryItems = [];
      this.actionLogData = [];
      this.publishedDate = "";
      this.deleteRefDocumentData = [];
      this.deleteRefDocumentDialog = false;
      this.popupString = "";
      this.popupFileName = "";
      this.uploadedReferenceFileDialog = false;
      this.loadDropdowns();
      this.getDocumentActionLogs();
      this.getDocumentDetails();
    },
    async loadDropdowns() {
      let masterObj = {
        pass: 0,
        user_id: parseInt(this.userId),
      };
      let masterData = await documentService.documentLoadMasters("post", masterObj, false);
      if (masterData.message !== "NA") {
        this.accountOptions = masterData.document_account;
        this.originOptions = masterData.document_origin;
        this.typeOptions = masterData.document_type;
        this.statusOptions = masterData.document_status;
        this.difficultyOptions = masterData.document_difficulty;
        this.personnelOptions = masterData.applicable_personnel;
        this.engineerOptions = masterData.document_engineer;
        this.authorOptions = masterData.document_author;
      }
    },
    async getDocumentActionLogs() {
      let obj = {
        document_id: parseInt(this.accountMastersEditID),
        user_id: parseInt(this.userId),
      };
      let data = await documentService.documentActionLogs("post", obj, false);
      if (data.message !== "NA") {
        const newArr = data.map((obj) => {
          return {
            ...obj,
            created_date: Utility.displayDateFormat(obj.created_date),
          };
        });
        this.actionLogData = newArr;
      }
    },
    async getDocumentDetails() {
      let obj = {
        document_id: parseInt(this.accountMastersEditID),
        user_id: parseInt(this.userId),
      };
      let data = await documentService.documentGetByID("post", obj, false);
      if (data.message !== "NA") {
        this.documentDetails = [];
        this.documentDetails = data;
        this.accountName = this.documentDetails[0]?.account_name;
        this.accountManager = this.documentDetails[0]?.manager_name;
        this.backupManager = this.documentDetails[0]?.backup_manager_name;
        this.selectedOriginID = this.documentDetails[0]?.origin_key;
        this.selectedTypeName = this.documentDetails[0]?.type_key;
        this.selectedDocumentNum = this.documentDetails[0]?.document_number;
        this.documentTitle = this.documentDetails[0]?.title;
        this.versionRevision = this.documentDetails[0]?.revision;
        this.author = this.documentDetails[0]?.author_key;
        this.engineer = this.documentDetails[0]?.engineer_key;
        this.timeRequired = this.documentDetails[0]?.time_required;
        this.statusID = this.documentDetails[0]?.status_key;
        this.difficultyID = this.documentDetails[0]?.difficulty_key;
        this.managementDoc = this.documentDetails[0]?.is_managment_doc;
        const raw = this.documentDetails[0]?.applicable_personnel;
        const parsed = JSON.parse(raw);
        this.applicablePersonnel = parsed.map((item) => item.role_key);
        this.trainingRequired = this.documentDetails[0]?.is_training_required;
        this.draftVersion = this.documentDetails[0]?.is_draft;
        this.isPublished = this.documentDetails[0]?.is_published;
        this.publishedDate =
          this.documentDetails[0]?.published_date == null ? "" : Utility.displayDateFormat(this.documentDetails[0]?.published_date);
        this.getReferenceDocumentDetails(this.documentDetails[0]?.document_id);
        if (this.statusID == 1 || this.statusID == 6 || this.statusID == 5) {
          this.disableSaveDraftVersion = false;
        } else if (this.statusID == 2) {
          this.draftVersion = false;
          this.disableSaveDraftVersion = true;
        } else {
          this.disableSaveDraftVersion = true;
        }
      }
    },
    //Drag and Drop Start
    onChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.dragging = false;
        return;
      } else {
        this.noFiles = false;
        this.createFile(files[0]);
      }
    },
    //Checking file details
    createFile(file) {
      const allowedExtensions = [".pdf"]; // add as needed
      const fileName = file.name.toLowerCase();
      const isValid = allowedExtensions.some((ext) => fileName.endsWith(ext));
      if (!isValid) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Invalid file type. Please select a PDF.",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.noFiles = true;
        this.dragging = false;
        return;
      }
      if (file.size > 50000000) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Size is more than 50MB",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.noFiles = true;
        this.dragging = false;
        return;
      }
      this.file = file;
      this.dragging = false;
    },
    //Removing dragged file
    removeFile() {
      this.file = "";
      this.noFiles = true;
    },
    //Drag and Drop Start
    onChangeOther(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files || !files.length) {
        this.draggingOther = false;
        return;
      }
      const totalFiles = 10 - this.refDocumentDetails.length;
      if (files.length > totalFiles) {
        let Alert = {
          type: "error",
          isShow: true,
          message: `You can upload a maximum of ${totalFiles} files only.`,
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.draggingOther = false;
        return;
      }
      this.noOtherFiles = false;
      for (let i = 0; i < files.length; i++) {
        this.createOtherFile(files[i]);
      }
      this.draggingOther = false;
      e.target.value = null;
    },
    //Checking file details
    createOtherFile(file) {
      const allowedExtensions = [".pdf", ".docx", ".xlsx", ".ppt", ".pptx", ".png"];
      const fileName = file.name.toLowerCase();
      const isValid = allowedExtensions.some((ext) => fileName.endsWith(ext));
      if (!isValid) {
        this.$store.commit("ConfigModule/Alert", {
          type: "error",
          isShow: true,
          message: "Invalid file type.",
        });
        return;
      }
      if (file.size > 50000000) {
        this.$store.commit("ConfigModule/Alert", {
          type: "error",
          isShow: true,
          message: "Size is more than 50MB",
        });
        return;
      }
      const alreadyExists = this.fileOther.some((f) => f.name === file.name && f.size === file.size);
      if (alreadyExists) return;
      this.fileOther.push(file);
    },
    //Removing dragged file
    removeOtherFile(index) {
      this.fileOther.splice(index, 1);
      if (this.fileOther.length == 0) {
        this.noOtherFiles = true;
      }
    },
    //On Account Change
    onAccountChange(value) {
      const selected = this.accountOptions.find((acc) => acc.account_id === value);
      if (selected) {
        this.accountManager = selected.manager_name;
        this.backupManager = selected.backup_manager_name;
      } else {
        this.accountManager = "";
        this.backupManager = "";
      }
    },
    toggleUploadedDialogWidth() {
      this.uploadedFileDialogWidth = this.uploadedFileDialogWidth === "100%" ? "1100" : "100%";
    },
    toggleRefUploadedDialogWidth() {
      this.uploadedRefFileDialogWidth = this.uploadedRefFileDialogWidth === "100%" ? "1100" : "100%";
    },
    submitEditDocument() {
      if (this.$refs.documentEditForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        const payload = this.applicablePersonnel.join(",");
        const formData = new FormData();
        formData.append("file", this.file);
        formData.append("user_id", parseInt(this.userId));
        formData.append("document_id", this.documentDetails[0]?.document_id);
        formData.append("account_key", this.documentDetails[0]?.account_key);
        formData.append("origin_key", parseInt(this.selectedOriginID));
        formData.append("type_key", parseInt(this.selectedTypeName));
        formData.append("document_number", this.selectedDocumentNum.toUpperCase());
        formData.append("title", this.documentTitle.toUpperCase());
        formData.append("revision", this.versionRevision.toUpperCase());
        formData.append("author_key", parseInt(this.author));
        formData.append("engineer_key", parseInt(this.engineer));
        formData.append("status_key", parseInt(this.statusID));
        formData.append("difficulty_key", parseInt(this.difficultyID));
        formData.append("time_required", this.timeRequired.toUpperCase());
        formData.append("is_managment_doc", this.managementDoc);
        formData.append("app_personnel_roles", payload);
        formData.append("is_training_required", this.trainingRequired);
        formData.append("is_draft_version", this.draftVersion);
        formData.append("version_number", this.versionRevision.toUpperCase());
        formData.append("original_file_name", this.file?.name == undefined ? "" : this.file?.name);
        formData.append("system_file_name", "");
        formData.append("filepath", "");
        this.axios
          .post("/du/document_update", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.body.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.submitReferenceDocument();
              this.resetFunction();
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
    //Download file function
    async downloadFile(item) {
      let data = await documentService.getDocumentSasFileUrl("get", item.system_file_name);
      if (data !== "") {
        this.base64String = data;
        this.uploadedFileDialog = true;
      }
    },
    //Delete Functionality
    documentDelete() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let obj = {
        user_id: parseInt(this.userId),
        document_id: parseInt(this.accountMastersEditID),
      };
      this.axios
        .post("/du/document_delete", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.$router.go(-1);
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Get data table data
    async viewDocumentHistory(item) {
      let obj = {
        document_id: parseInt(item.document_id),
        user_id: parseInt(this.userId),
      };
      let data = await documentService.documentHistory("post", obj, false);
      if (data.message !== "NA" && data.length !== 0) {
        const newArr = data.map((obj) => {
          return {
            ...obj,
            uploaded_date: obj.uploaded_date !== null ? Utility.displayDateFormat(obj.uploaded_date) : "",
          };
        });
        this.documentHistoryItems = newArr;
        this.documentHistoryDialog = true;
      } else {
        this.documentHistoryItems = [];
        this.documentHistoryDialog = false;
      }
    },
    submitReferenceDocument() {
      if (this.fileOther.length !== 0) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        this.fileOther.forEach((file) => {
          const formData = new FormData();
          formData.append("file", file); // ✅ use current file
          formData.append("pass", 1);
          formData.append("document_id", parseInt(this.documentDetails[0]?.document_id));
          formData.append("user_id", parseInt(this.userId));
          formData.append("reference_id", 0);
          formData.append("original_file_name", file?.name); // ✅ use current file
          formData.append("system_file_name", "");
          formData.append("file_path", "");
          this.axios
            .post("/du/reference_document_insert", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              if (response.status == 200 || response.status == 204) {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.errorMessage = error.message;
            });
        });
      }
    },
    getReferenceDocumentDetails() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      const formData = new FormData();
      formData.append("pass", 4);
      formData.append("document_id", parseInt(this.documentDetails[0]?.document_id));
      formData.append("user_id", parseInt(this.userId));
      formData.append("reference_id", 0);
      formData.append("original_file_name", "");
      formData.append("system_file_name", "");
      formData.append("file_path", "");
      this.axios
        .post("/du/reference_document_insert", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let data = JSON.parse(response.data.body.message);
            if (data !== null) {
              this.refDocumentDetails = data;
            } else {
              this.refDocumentDetails = [];
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Document Status Change
    changeDocumentStatus() {
      if (this.statusID == 1 || this.statusID == 6 || this.statusID == 5) {
        this.disableSaveDraftVersion = false;
      } else if (this.statusID == 4 || this.statusID == 3) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "You cannot set the status to Approved or Management Review, as the document must first pass through the initial approval stage.",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.statusID = "";
        this.disableSaveDraftVersion = true;
      } else if (this.statusID == 2) {
        this.draftVersion = false;
        this.disableSaveDraftVersion = true;
      } else {
        this.disableSaveDraftVersion = true;
      }
    },
    //Change in Engineer
    changeEngineer() {
      if (this.documentDetails[0]?.manager_id == this.engineer) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Engineer cannot be same as Account Manager",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.engineer = "";
      }
    },
    //Delete Reference Document Details
    deleteRefDocDetails(item) {
      this.deleteRefDocumentData = item;
      this.deleteRefDocumentDialog = true;
    },
    //Close of delete confirmation dialog
    onClose() {
      this.deleteRefDocumentData = [];
      this.deleteRefDocumentDialog = false;
    },
    deleteRefDocumentDetails(data) {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      const formData = new FormData();
      formData.append("pass", 3);
      formData.append("document_id", parseInt(this.documentDetails[0]?.document_id));
      formData.append("user_id", parseInt(this.userId));
      formData.append("reference_id", data.reference_id);
      formData.append("original_file_name", "");
      formData.append("system_file_name", "");
      formData.append("file_path", "");
      this.axios
        .post("/du/reference_document_insert", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.onClose();
            this.getReferenceDocumentDetails(this.documentDetails[0]?.document_id);
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    async getSasFileData(item) {
      let data = await documentService.getDocumentSasFileUrl("get", item.system_file_name);
      if (data !== "") {
        this.popupFileName = this.getFileType(item.original_file_name);
        this.popupString = data;
        this.uploadedReferenceFileDialog = true;
      }
    },
    getFileType(fileName) {
      if (!fileName) return "";
      const ext = fileName.split(".").pop().toLowerCase();
      if (["pdf"].includes(ext)) return "pdf";
      if (["doc", "docx"].includes(ext)) return "docx";
      if (["ppt", "pptx"].includes(ext)) return "pptx";
      if (["xls", "xlsx"].includes(ext)) return "xlsx";
      if (["png", "jpg", "jpeg"].includes(ext)) return "image";
      return "unknown";
    },
    actionSetter(permission) {
      return Utility.actionSetter(this.actionList, permission);
    },
    documentRedirect() {
      let accountDetails = EncryptUtility.localStorageDecrypt("accountMastersDetails");
      if (accountDetails !== undefined) {
        this.$router.push({
          name: "documentMastersAccountList",
          params: {
            accountMastersDetails: btoa(accountDetails),
          },
        });
      } else {
        this.$router.push("/document-account-list");
      }
    },
  },
  components: {
    breadcrumbComp,
  },
};
